module.exports = __webpack_public_path__ + "static/media/baby_yoda@1x.a10d05f3.png";